import { PLATFORM } from "../../platform";
export default (function (user, tenant) { return ({
    user_id: user.uuid,
    tenant_locale: user.locale || tenant.locale,
    tenant_id: user.tenant,
    tenant_grouping: tenant.groupId,
    tenant_subdomain: tenant.subdomain,
    tenant_public_name: tenant.public_name,
    perkbox_platform: PLATFORM,
    roles: Array.isArray(user.roles) ? user.roles : []
}); });
